import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import Language from "../../../../../../../../../../services/Language";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: RentCellContent.Props["item"]) => {
	if (!isNumber(item?.executorRate?.rent)) return "";
	return formatNumber(item?.executorRate?.rent);
};

const RentCellContent: React.FC<RentCellContent.Props> = ({ item }) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace RentCellContent {
	interface Props {
		item: ExecutorReport.Model;
		language: Language;
	}
}

export default RentCellContent;
